'use strict';

var KeyMirror = require('keymirror');

module.exports = {
    ActionTypes: KeyMirror({
        VALIDATE_REGULAR_INVESTMENT_PLAN: null,
        UPDATE_RIP_INVEST_ALLOCATION_QTY: null,
        MONTHLY_AMOUNT_ALLOCATION: null,
        UPDATE_RIP_DATA: null,
        UPDATE_REGULAR_INVESTMENT_PLAN: null
    }),
    NOMINATE_OTHER_ACCOUNT: 'nominate',
    RIP_INV_OPT_PREFIX: 'ripInvstOption-',
    RegularInvestmentPlanData: {
        ripOption: '',
        personalContribution: '',
        spouseContribution: '',
        monthlyAmountContribution: '',
        selectedBankAccount: '',
        nameOfAccountHolder: '',
        bankAccountHeldOption: '',
        branchNumber: '',
        bankAccount: '',
        sameAsInvestAllocationOption: '',
        investmentOptionList: [],
        consumerPriceIndex: '',
        totalContribution: '0.00',
        totalAllocationPercentage: '0.00'
    },
    RegularInvestmentPlanErrorState: {
        investmentOptionsAreOutOfSyncCopy: true,
        dateOfBirthOutOfSyncCopy: true,
        listBankAccountRequiredValid: true,
        accountNumberFutureRequest: false,
        excludedInvestment: true,
        specifyBankAccountValid: true,
        errorList: []
    },
    Labels: {
        setupRegularInvestmentPlan: 'Set up regular investment plan',
        investmentPlanSetupWith: 'Regular investment plan set up with',
        personalContribution: 'Personal contribution',
        spouseContribution: 'Spouse contribution',
        monthlyAmount: 'Monthly amount',
        debitedFromFollowingAccount: 'Debited from the following account',
        noteBankAccountHeld: 'You have advised us that this account is not held in your name. Please complete the Direct Debit Authority Form.',
        noteBankAccountHeldInvestment: 'You have advised us that this account is not held in your name. Please arrange for the completion of the Direct Debit Authority Form.',
        yearlyIncrease: 'Your contributions increase each year',
        yearlyIncreaseInvestments: 'Your payments increase each year',
        investmentAllocation: 'Investment allocation',
        cpiYes: 'Yes, based on CPI (or 3%, whichever is greater)'
    }
};


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./constants/RegularInvestmentPlanConstants.js